// src/core/reviewsApi.js
import { axiosClient } from "./axiosClient";


/**
 * REVIEWS API
 * Public:
 *  - GET /reviews/
 *  - POST /reviews/
 *
 * Admin (JWT staff):
 *  - DELETE /reviews/{id}/  (soft delete)
 */

export const getReviewsPublic = async () => {
  const res = await axiosClient.get("/reviews/");
  return res.data;
};

export const createReviewPublic = async (payload) => {
  const res = await axiosClient.post("/reviews/", payload);
  return res.data;
};

export const deleteReviewAdmin = async (id) => {
  const res = await axiosClient.delete(`/reviews/${id}/`);
  return res.data;
};
